import { z } from 'zod'

export const ATTRIBUTE_TYPES = ['date', 'text', 'number', 'boolean', 'price'] as const

export const AttributeTypesSchema = z.enum(ATTRIBUTE_TYPES)

export type AttributeType = z.infer<typeof AttributeTypesSchema>

export const CRITICALITY_VALUES = ['major', 'moderate', 'informational'] as const

export const CriticalitySchema = z.enum(CRITICALITY_VALUES)

export type Criticality = z.infer<typeof CriticalitySchema>
